import React, { useEffect, useState } from "react";
import { Col, Container, Row, Label, Input } from "reactstrap";
import NameLoginVideo from "../../../../assets/video/certifiction.mp4";
// import VerifiImage from "../../../../assets/image/verificationlogo.svg"
import logoImage from "../../../../assets/image/logocomplyer-logo.svg";
import ReactCodeInput from "react-code-input";
//assets
import logo from "../../../../assets/image/logo.svg";
const CODE_LENGTH = 6
export const Code = ({
  onSubmit,
  onChangePhone,
  phoneNumber,
  loading,
  error,
}) => {
  const [code, setCode] = useState('')
  const [otp, setOtp] = useState('')
  const [resendVisible, setResendVisible] = useState(false)
  let [formErrors, setFormErrors] = useState({})
  useEffect(() => {
    setOtp(localStorage.getItem('otp'))
    let newotp = localStorage.getItem('otp')
    console.log("the code is", code, newotp)
    if (code.length === 6) {
      onSubmit(code, otp)
    }


  }, [code])
  useEffect(() => {
    const timeout = setTimeout(() => {
      setResendVisible(true)
    }, 10 * 1000)

    // cancel timeout on unmount
    return () => clearTimeout(timeout)
    setOtp(localStorage.getItem('otp'))
  }, [])




  return (
    <section>
      {/* <section className="lyt-section typ-login">
      <Container>
        <Row className="align-items-center justify-content-center">
          <Col xs={12} sm={12} md={12} lg={6} xl={5}>
            <div className="bs-card typ-login">
              <div className="img-area">
                <picture>
                  <source media="(max-width:992px)" srcSet={logo} />
                  <img src={logo} alt="GLYPHER TECH LOGO" />
                </picture>
              </div>
              <form className="bs-form" >
                <p className="otp-desc">
                  Enter the 6-digit code send to <strong>{phoneNumber}</strong>{" "}
                </p>

                <div className="input-area">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginbottom: 50,
                    }}
                  >
                    <ReactCodeInput
                      type="tel"
                      fields={6}
                      className="ReactCodeInput otp-input-wrapper"
                      inputStyle={{
                        fontFamily: "roboto",
                        MozAppearance: "textfield",
                        width: "41px",
                        borderRadius: "5px",
                        fontSize: "20px",
                        height: "41px",
                        paddingLeft: "0px",
                        backgroundColor: "white",
                        border: "1px solid rgba(0,0,0,0.4)",
                        outline: "none",
                        textAlign: "center",
                        margin: "2px",
                      }}
                      id="code"
                      placeholder={'123456'}
                      onChange={(value) => setCode(value)}
                      required
                    />
                  </div>
                </div>
                <p className="error-message">{formErrors.company}</p>
                {error && <p style={{position: "absolute", fontSize: '12px',color: "#d73038",margin: "10px 10px",fontFamily: 'roboto',fontWeight: 500}}>{error}</p>}
                <button
                  style={{ marginTop: 30 }}
                  className="bs-btn typ-login"
                  type="button"
                  onClick={() => onSubmit(code)}
                >
                  Sign In
                </button>
              </form>
            </div>
          </Col>
        </Row>
      </Container> 
      </section> */}




      <section>

        <div className="vh-100 d-flex">
          <Row className="w-100 d-flex h-100">
            {/* Left Side: Image Section */}
            <Col lg={7} className="d-flex h-100">
              <div className="w-100 d-flex align-items-center justify-content-center h-100 bg-light">
               <video
                                className="img-fluid"
                                style={{ maxHeight: "100%" }}
                                autoPlay
                                loop
                                muted
                                playsInline
                              >
                                <source src={NameLoginVideo} type="video/mp4" />
                              </video>
              </div>
            </Col>

            {/* Right Side: Verification Code Section */}
            <Col
            
              className="d-flex align-items-center justify-content-center h-100"
            >
              <form className="bs-form" >
                {/* <img
                  src={VerifiImage}
                  alt="Login Illustration"
                  className="img-fluid"
                  style={{ maxHeight: "100%" }}
                /> */}
                <div className="d-flex justify-content-center">
                                    <img
                                      src={logoImage}
                                      alt="Login Illustration"
                                      className="img-fluid"
                                      style={{ width: "230px" }}
                                    />
                                  </div>
                
                                  <h1
                                    style={{
                                      fontFamily: 'Segoe UI, sans-serif',
                                      fontWeight: 600,
                                      fontSize: '24px',
                                      lineHeight: '100%',
                                      letterSpacing: '0px',
                                      color: 'rgba(26, 26, 51, 1)',
                                      margin: 0,
                                      paddingTop: "30px",
                                      textAlign:'center'
                                    }}
                                  >
                                   Enter Verification Code
                                  </h1>

                <div className="input-area mt-4">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginbottom: 50,
                    }}
                  >
                    <ReactCodeInput
                      type="tel"
                      fields={6}
                      className="ReactCodeInput otp-input-wrapper"
                      inputStyle={{
                        fontFamily: "roboto",
                        MozAppearance: "textfield",
                        width: "41px",
                        borderRadius: "5px",
                        fontSize: "20px",
                        height: "41px",
                        paddingLeft: "0px",
                        backgroundColor: "white",
                        border: "1px solid rgba(0,0,0,0.4)",
                        outline: "none",
                        textAlign: "center",
                        margin: "2px",
                      }}
                      id="code"
                      placeholder={'123456'}
                      onChange={(value) => setCode(value)}
                      required
                    />
                  </div>
                </div>
                <p className="error-message">{formErrors.company}</p>
                {error && <p style={{ position: "absolute", fontSize: '12px', color: "#d73038", margin: "10px 10px", fontFamily: 'roboto', fontWeight: 500 }}>{error}</p>}
                {/* <button
                  style={{ marginTop: 30 }}
                  className="bs-btn typ-login bg-dark"
                  type="button"
                  onClick={() => onSubmit(code)}
                >
                 Login
                </button> */}
                <button
                  onClick={() => onSubmit(code)}
                  className="typ-login bg-dark border-secondary text-white w-100 py-2 rounded"
                  style={{ marginTop: 30 }}
                  type="button"
                >
                  Login
                </button>
              </form>
            </Col>
          </Row>

        </div>
      </section>

    </section>
  );
}

export default Code;
